export class User {
    id: number;
    name: string;
    username: string;
    password: string;
    language: string;
    email: string;
    user_role_id: number;
}
